import { Stack } from "../../../foundations/grid-layout/Stack";
import { Popover } from "../../popover/Popover";

import {
  ColorPicker as AriaColorPicker,
  ColorPickerProps as AriaColorPickerProps,
  Button,
} from "react-aria-components";

import { DialogTrigger } from "../../popover/DialogTrigger";
import {
  FieldErrors,
  FieldErrorsProps,
} from "../_assets/input-wrapper/FieldErrors";
import { FormLabelRAC } from "../_assets/input-wrapper/FormLabelRAC";
import { ColorArea } from "./ColorArea";
import { ColorSlider } from "./ColorSlider";
import { ColorField } from "./ColorField";
import { ColorSwatch } from "./ColorSwatch";
import { ColorPickerActions } from "./ColorPickerActions";
import { PopoverContent } from "../../popover/PopoverContent";
import { css } from "@emotion/css";
import { useState } from "react";
import { BrandProvider } from "./../../../context/BrandProvider";
export interface ColorPickerProps
  extends Omit<AriaColorPickerProps, "className" | "style" | "children"> {
  label: string;
  info?: React.ReactNode;
  isRequired?: boolean;
  errors?: FieldErrorsProps["children"];
  testID: string;
  isDisabled?: boolean;
  onCancel?: () => void;
  onDone?: (color: string) => void;
  onReset?: () => void;
}

export function ColorPicker(props: ColorPickerProps) {
  const {
    label,
    info,
    isRequired,
    errors,
    testID,
    isDisabled,
    value,
    onCancel,
    onDone,
    onReset,
    ...picker
  } = props;

  const [originalColor] = useState<string | undefined>(
    typeof value === "string" ? value : value?.toString("hex")
  );

  return (
    <BrandProvider global={false}>
      <Stack gap="space-1">
        <FormLabelRAC info={info} isRequired={isRequired}>
          {label}
        </FormLabelRAC>
        <AriaColorPicker {...picker} value={value}>
          <DialogTrigger
            trigger={
              <Button className={styles.button} isDisabled={isDisabled}>
                <ColorSwatch />
              </Button>
            }
          >
            <Popover placement="right bottom">
              <PopoverContent>
                <ColorArea
                  colorSpace="hsb"
                  xChannel="saturation"
                  yChannel="brightness"
                />
                <ColorSlider colorSpace="hsb" channel="hue" />
                <ColorField label="Hex" />
                <ColorPickerActions
                  testID={testID}
                  onCancel={onCancel}
                  onDone={onDone}
                  onReset={onReset}
                  originalColor={originalColor}
                />
              </PopoverContent>
            </Popover>
          </DialogTrigger>
        </AriaColorPicker>
        <FieldErrors>{errors}</FieldErrors>
      </Stack>
    </BrandProvider>
  );
}

const styles = {
  button: css({
    all: "unset",
    width: "fit-content",
    cursor: "pointer",
    borderRadius: "var(--border-radius-2)",
    padding: "var(--space-1)",
    "&:focus-visible": {
      boxShadow: "var(--focus-action)",
    },
  }),
};
